import React, { useEffect } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import { AnimatePresence } from "framer-motion";
import { routes } from "./routerConfig";

const ScrollToTop = withRouter(({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
});

const BodyRouter = () => {
  return (
    <Route
      render={({ location }) => (
        <AnimatePresence initial={location.pathname === "/"}>
          <ScrollToTop />
          <Switch location={location} key={location.pathname}>
            {routes.map((route) => (
              <Route
                key={route.key}
                path={route.path}
                children={<route.body />}
                exact={route.exact}
              />
            ))}
          </Switch>
        </AnimatePresence>
      )}
    />
  );
};

export default BodyRouter;
